<template>
    <div class="product">
        <div class="pic">
            <img src="../assets/img/product-bg.png" alt="">
        </div>
        <main class="main">
            <div class="work">
                <div class="wLeft">
                        初创期财务解决方案适用于初创型，且对财务服务要求不高的
                        公司。为企业提供较为价格便宜、服务质量高的记账报税服务，
                        为未来发展作准备。
                </div>
                <div class="wRight">
                        发展期财务解决方案适用于发展型，有融资需求的公司。
                        为企业主提供专业的、能真实反馈企业经营状况的财务服务。
                </div>
            </div>
            <div class="financial-plan-pic">
                <img src="../assets/img/product－image－1.png" alt="">
            </div>

            <h2>我们通过什么产品来解决你的问题</h2>
            <div class="introduce" v-for="(item,i) in list" :key="i">
                <div class="title" :id="'a' + item.typeCode">
                     <!-- :style="{background: 'url(' + item.iconPath + ') no-repeat'}" -->
                    <!-- <img :src="item.iconPath" alt="" > -->
                    <h3>{{item.typeName}}</h3>
                    <p>{{item.typeDesc}}</p>
                </div>
                <div class="corporation" v-for="(json,i) in item.productList" :key="i">
                    <img :src="json.coverUrl" alt="">
                    <div class="neirong">
                        <h3>{{json.name}}</h3>
                        <p>{{json.price}}</p>
                        <span @click="toDetail(json)">查看详情</span>
                        <!-- <a :href="json.urlPath" target="_blank">查看详情</a> -->
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { getProductList } from '../api/api.js'

export default {
  name: 'product',
  data () {
    return {
      list: [],
      introduceList: [
        {
          title: '财务核算',
          describe: '基础核算的口径不一致，无法提供有力的数据分析？',
          iconPath: require('../assets/img/product1.png'),
          anchorLink: 'cwhs',
          productCorporation: [
            {
              id: 7,
              img: require('../assets/img/核算通_迷你版_封面.jpg'),
              title: '核算通（迷你版）',
              proce: '￥1500.00-28800.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1yf4mw0125hs8&activity='
            },
            {
              id: 6,
              img: require('../assets/img/核算通_标准版_封面.jpg'),
              title: '核算通（标准版）',
              proce: '￥12000.00-76800.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=2fvb5yoszuz14&activity='
            },
            {
              id: 5,
              img: require('../assets/img/核算通_定制包_封面.jpg'),
              title: '核算通（定制包）',
              proce: '￥1000.00-20000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=276fdwoyeskzc&activity='
            },
            {
              id: 4,
              img: require('../assets/img/核算通_内训版_封面.jpg'),
              title: '核算通（内训版）',
              proce: '￥5000.00-10000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=2olelkccdsa94&activity='
            }
          ]
        },
        {
          title: '预算管控',
          describe: '是否苦恼有了战略方向，但迟迟不能落地？',
          iconPath: require('../assets/img/product2.png'),
          anchorLink: 'cwys',
          productCorporation: [
            {
              id: 3,
              img: require('../assets/img/预算管控_迷你版.jpg'),
              title: '预算管控（迷你版）',
              proce: '￥18000.00-72000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3f2v4n2omw3ig&activity='
            },
            {
              id: 2,
              img: require('../assets/img/预算管控_标准版.jpg'),
              title: '预算管控（标准版）',
              proce: '￥45000.00-180000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=276hmzzi4jf48&activity=='
            },
            {
              id: 1,
              img: require('../assets/img/预算决策.jpg'),
              title: '预算决策',
              proce: '￥12000.00-25000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3emt9knsu06pk&activity='
            },
            {
              id: 8,
              img: require('../assets/img/预算内训.jpg'),
              title: '预算管控（内训课程）',
              proce: '￥5000.00-10000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3np8o3r73kpyw&activity='
            }
          ]
        },
        {
          title: '财务猎人',
          describe: '公司情况比较复杂，面试一直找不到最合适的财务人员？',
          iconPath: require('../assets/img/product3.png'),
          anchorLink: 'cwlr',
          productCorporation: [
            {
              id: 9,
              img: require('../assets/img/product－image－4.png'),
              title: '会计岗位推荐',
              proce: '￥7200.00-9600.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1y41pxj0fjhqg&activity='
            },
            {
              id: 10,
              img: require('../assets/img/product－image－4.png'),
              title: '财务主管推荐',
              proce: '￥10800.00-13500.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=26vcgmrke5jeg&activity='
            },
            {
              id: 11,
              img: require('../assets/img/product－image－4.png'),
              title: '财务经理推荐',
              proce: '￥12000.00-18000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1ydw4drw90qnc&activity='
            },
            // {
            // img:require('../assets/img/product－image－4.png'),
            // title:'财务经理推荐（51-80人）',
            // proce:'￥15000.00',
            // urlPath:'https://detail.youzan.com/show/goods?alias=1yhm0zfq7fgeg&activity='
            // },
            // {
            // img:require('../assets/img/product－image－4.png'),
            // title:'财务经理推荐（80人以上）',
            // proce:'￥18000.000',
            // urlPath:'https://detail.youzan.com/show/goods?alias=2g098nc2dt7g8&activity='
            // },
            {
              id: 12,
              img: require('../assets/img/product－image－4.png'),
              title: '财务总监岗位',
              proce: '￥30000.00-70000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1ycmwpofor6x4&activity='
            }
            // {
            // img:require('../assets/img/product－image－4.png'),
            // title:'财务总监推荐（51-80人）',
            // proce:'￥48000.00',
            // urlPath:'https://detail.youzan.com/show/goods?alias=3f0es7eysiulk&activity='
            // },
            // {
            // img:require('../assets/img/product－image－4.png'),
            // title:'财务总监推荐（80人以上）',
            // proce:'￥70000.00',
            // urlPath:'https://detail.youzan.com/show/goods?alias=272s908vuqt08&activity='
            // },
          ]
        },
        {
          title: '税务辅导',
          describe: '到年底了，该给员工发年终奖了，却为发放的标准愁的不行？',
          iconPath: require('../assets/img/product4.png'),
          anchorLink: 'swch',
          productCorporation: [
            {
              id: 13,
              img: require('../assets/img/税务筹划_省个税.jpg'),
              title: '税务辅导（省个税）',
              proce: '￥3888',
              urlPath: 'https://detail.youzan.com/show/goods?alias=366kevn080nl4&activity='
            },
            {
              id: 14,
              img: require('../assets/img/税务筹划_优税宝.jpg'),
              title: '税务辅导（优税宝）',
              proce: '￥12000.00-100000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3nvfxy5215ayg&activity='
            },
            {
              id: 15,
              img: require('../assets/img/税务筹划_内训版.jpg'),
              title: '税务辅导（内训版）',
              proce: '￥5000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3nswu13cw3f54&activity='
            }
          ]
        },
        {
          title: '股权激励',
          describe: '公司发展的不错，想要给员工股权激励，却不知如何分配？',
          iconPath: require('../assets/img/product5.png'),
          anchorLink: 'gqjl',
          productCorporation: [
            {
              id: 16,
              img: require('../assets/img/股权激励_标准版.jpg'),
              title: '股权激励（标准版）',
              proce: '￥47000.00-180000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=366jpqnmhmf9k&activity=' },
            {
              id: 17,
              img: require('../assets/img/股权激励_方案版.jpg'),
              title: '股权激励（方案版）',
              proce: '￥38000.00-108000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1ygbxwzg1b520&activity='
            },
            {
              id: 18,
              img: require('../assets/img/股权激励_内训版.jpg'),
              title: '激励（内训课程）',
              proce: '￥5000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3nqiedu3640y0&activity=y=' },
            {
              id: 19,
              img: require('../assets/img/股权激励_文件包.jpg'),
              title: '股权激励（文件包）',
              proce: '￥1',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3ep99gqot03qg&activity=='
            }
          ]
        },
        {
          title: '年中复盘',
          describe: '财务管理上总是有捋不顺的地方，就是纠不出问题出在哪儿？',
          iconPath: require('../assets/img/product6.png'),
          anchorLink: 'lzfp',
          productCorporation: [
            {
              id: 20,
              img: require('../assets/img/product－image－13.png'),
              title: '橙蟹财务产品-年中财务复盘（10-20人）',
              proce: '￥1000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=2fu2zt1kbd3t4&activity='
            },
            {
              id: 21,
              img: require('../assets/img/product－image－14.png'),
              title: '橙蟹财务产品-年中财务复盘（21-50人）',
              proce: '￥2000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=3ez46ncz7u060&activity='
            },
            {
              id: 22,
              img: require('../assets/img/product－image－15.png'),
              title: '橙蟹财务产品-年中财务复盘（51-90人）',
              proce: '￥3000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=2fz010467kjp4&activity='
            },
            {
              id: 23,
              img: require('../assets/img/product－image－16.png'),
              title: '橙蟹财务产品-年中财务复盘（90人以上）',
              proce: '￥4000.00',
              urlPath: 'https://detail.youzan.com/show/goods?alias=1yhkzebg0tl20&activity='
            }
          ]
        },
        {
          title: '年终复盘',
          describe: '公司日复一日原地踏步，没有逾期目标没有实际驱动力',
          iconPath: require('../assets/img/product7.png'),
          anchorLink: 'nzfp',
          productCorporation: [
            {
              id: 24,
              img: require('../assets/img/product－image－17.png'),
              title: '年终财务复盘（10-20人）',
              proce: '根据服务内容而定',
              urlPath: 'https://detail.youzan.com/show/goods?alias=2759adwwyeans&activity='
            }
          ]
        }
      ]
    }
  },
  methods: {
    toDetail (item) {
      this.$router.push({ path: '/productDetail/' + item.companyProductId })
    },
    getlist () {
      getProductList().then(res => {
        console.log(res)
        if (res.status == 200) {
          this.list = res.data.data.list.map(item => {
            item.productList = item.productList.map(value => {
              value.coverUrl = 'http://121.40.191.9/uploads/image' + value.coverUrl
              return value
            })
            return item
          })
        }
      })
    }
  },
  created () {
    this.getlist()
    // window.scrollTo
    setTimeout(() => {
      let obj = document.querySelector('#' + this.$route.query.type)
      if (obj) {
        obj.scrollIntoView(true)
      }
    }, 400)
    console.log(this.$route, this.$route.query.type)
  }
}
</script>

<style scoped>
    /* 图片 */
    .pic{
        width: 100%;
        height: 30%;
    }
    .pic img{
        width: 100%;
        height: 100%;
    }
    /* 主体内容 */
    .main{
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
    }
    .main .work{
        /* margin-top: -2%; */
        display: flex;
        margin-left: 18%;
        margin-top: -2%;
    }
    .work .wLeft{
        width: 29%;
        background-color: #2e324f;
        color: #ffffff;
        padding: 10px 20px;
    }
    .work .wRight{
        width: 30%;
        background-color: #ff6000;
        color: #ffffff;
        padding: 10px 20px;
    }
    .main .financial-plan-pic{
        width: 100%;
        height: 36%;
        margin: 5% 0;
        /* margin-left: 7% */
    }
    .financial-plan-pic img{
        width: 100%;
        height: 100%;
    }
    .main h2 {
        color: #2e324f;
        font-size: 32px;
        text-align: center;
        padding: 3% 0;
    }

    /* 产品 */
    .introduce .title{
        width: 100%;
        padding: 1% 0;
    }
    .title img{
        display: inline-block;
        width: 5%;
        float: left;
    }
    .title h3{
        color:#2e324f;
        font-size: 22px;
    }
    .introduce .corporation{
        display: inline-block;
        width: 23%;
        margin-right: 2%;
        margin-bottom: 2%
        /* text */
    }
    .corporation{
        background-color: #fff
    }
    .corporation .neirong{
        padding-left: 10px;
    }
    .corporation img{
        width: 100%;

    }
    .neirong h3{
        font-size: 14px;
    }
    .neirong p{
        color: #ff6000;
    }
    .neirong span{
        display: inline-block;
        border: 1px solid #2e324f;
        color: #2e324f;
        padding: 2% 2%;
        border-radius: 6px;
        margin: 1% 0 3% 0;
        font-size: 12px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/product.vue